export default __webpack_public_path__ + "images/F2.db88127.png";